// extracted by mini-css-extract-plugin
export default {"please":"GetReport_please__072h6","labelradio":"GetReport_labelradio__UtOYO","hide4printing":"GetReport_hide4printing__c--AO","margin4printing":"GetReport_margin4printing__ODr-o"};